import React from "react";
import { getWorkflowSteps, getDefault } from "components/workflows/DisputeTransactionWorkflow";
import Classes, { Transaction } from "model";
import { UIPrimaryButton } from "components/ui/UIButton";
import { BCMSRecord, useRoute, useBCMSContext, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";
import DisputeTransactionDetailsWidget from "../widgets/DisputeTransactionDetailsWidget";

/**
 * @function DisputeSubmittedView
 * @param {NUMBER} confirmationNumber - The confirmation number was generated when the dispute was filed. 
 * @param {STRING} merchantDescription - The description of which merchant made the transaction. 
 * @param {DECIMAL} disputeAmount - The amount of the transaction. 
 * @param {STRING} transactionDate - The date the transaction was made. 
 * @param {STRING} submissionDate - The date the report was made. 
 * @param {STRING} reason - The reason that was selected for the dispute from the previous workflow step. 
 * @param {STRING} additionalComments - Comments written by the user in the previous workflow step. 
 * @return {React.Component}
 * @exported true
 * @description This is the last view shown after the reason for the dispute is selected. 
 * @example
 * <DisputeSubmittedView confirmationNumber="XXXXXXXXXXX" merchantDescription="merchantDescription" disputeAmount="XX.XX" transactionDate="Month XX, XXXX" submissionDate="Month XX, XXXX" reason="reason" additionalComments="additionalComments" />
 */
export default function DisputeSubmittedView(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor([ Transaction ], globalController);
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const workflowStepState = workflowStep.getStepState;
  const merchantDescription = workflowStepState.transaction.merchant.description ?? "[merchantDescription]";
  const disputeAmount = workflowStepState.transaction.amount.format() ?? "[disputeAmount]";
  const transactionDate = workflowStepState.transaction.purchaseDate.format('M d, Y') ?? "[transactionDate]";

  const confirmationNumber = workflowStepState.confirmationNumber ?? "[XXXXXXXXXXX]";
  const submissionDate = workflowStepState.disputeSubmissionDate.format('M d, Y');
  const reason = workflowStepState.disputeReason;
  const additionalComments = workflowStepState.disputeReasonAdditionalComments;
  const transactionID = workflowStepState.transaction.id;
  const cardID = workflowStepState.transaction.card.id ?? "0";

  const navigate = useRoute();
  const ok = evt => {
    let transaction = Transaction.initByID(transactionID);
    transaction.disputeTransaction = true;
    BCMSRecord.batch([
      Transaction.update(transaction)
    ], globalController, Classes);
    navigate(`/home/viewalltransactions/${cardID}/disputeTransactionWorkflow`);
  }

  return (
    <div className="dispute-submitted-view text-center">
      <div className="framed-icon-container">
        <SVGAsset id="CheckmarkIcon" />
      </div>
      <p><b>Your dispute has been submitted.</b></p>
      <DisputeTransactionDetailsWidget />
      <UIPrimaryButton text="OK" onClick={ok}/>
    </div>
  );
}